import { render } from "./BlockCustomizations.vue?vue&type=template&id=6d39baf3&scoped=true"
import script from "./BlockCustomizations.vue?vue&type=script&lang=js"
export * from "./BlockCustomizations.vue?vue&type=script&lang=js"

import "./BlockCustomizations.vue?vue&type=style&index=0&id=6d39baf3&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d39baf3"]])

export default __exports__